<template>
  <div class="post type-post hentry" id="post-2">
    <h2>
      <router-link
        to="/2011/01/kas-tai-preliminarioji-sutartis/"
        >Kas tai – preliminarioji sutartis</router-link
      >
    </h2>
    <div class="comm_date">
      <span class="month">Sausio</span><span class="date_nr">12</span>
    </div>
    <div class="entry">
      <p>
        Santykiai tarp žmonių ne visada grindžiami sąžine ir pasitikėjimu, todėl
        turto perleidimo sandorių įforminimas tampa vis sudėtingesniu.
      </p>
      <p>
        Interesantai nuolat domisi, kaip patikimai užfiksuoti būsimo turto
        perleidimo sandorio (pirkimo-pardavimo, mainų, dovanojimo) sutartas
        sąlygas – kainą, terminus, komplektaciją, kokybę ir kitas dalykus.
      </p>
      <p>
        Lietuvoje neseniai buvo protinga ir patikima tradicija – būsimąjį
        sandorį užtikrinti rankpinigiais. Žmonės ir įmonės dar ir dabar
        kreipiasi, prašydami padėti įforminti rankpinigius. Tačiau nuo 2001 m.
        liepos įsigaliojęs Civilinis kodeksas šią garantijos formą, nežinia dėl
        ko, įsakmiai susiaurino. Pagal įstatymą rankpinigiai dabar galimi tik
        sandoriuose dėl kai kurių nereikšmingų turto rūšių, pvz.: gyvulių, javų,
        medienos, dviračio… LR CK 6.98 str. kategoriškas:&nbsp;<strong
          >Rankpinigiais negali būti užtikrinama preliminarioji sutartis, t.p.
          sutartis, kuriai pagal įstatymus privaloma notarinė forma</strong
        >. Taigi, perkant pastatus, butus, žemę, mišką, rankpinigiai, kur jie
        mums patogiausi ir reikalingiausi, dabar jau nebegali būti garantijos
        priemone.
      </p>
      <p>
        Kaip rasti išeitį, ir kaip užsitikrinti būsimo planuojamo sandorio
        garantijas?
      </p>
      <p>
        Atsivertę Civilinio kodekso šeštąją knygą, randame nežymų 6.165
        straipsnį „Preliminarioji sutartis“, ir matome, kad tokia&nbsp;sutartimi
        laikomas šalių&nbsp;<strong>rašytinis</strong> susitarimas, pagal kurį
        jame aptartomis sąlygomis šalys įsipareigoja ateityje sudaryti kitą –
        pagrindinę – sutartį.
      </p>
      <p>
        Tinkamai surašius, tokia sutartis tampa patikima abiejų rengiamo
        sandorio šalių ketinimų, teisių, pareigų ir prievolių garantija. Sutartį
        galima tobulinti, numatant bet kurias įstatymo neuždraustas sąlygas bei
        įvairiausius „saugiklius“ bet kuriam atvejui, garantuojančius visų dėl
        būsimos sutarties sudarymo numatytų sąlygų įvykdymo mechanizmus,
        neteisiajai šaliai grasinančius piniginėmis bei turtinėmis pasekmėmis –
        baudomis, delspinigiais, avansinio mokėjimo netekimu ir kt.. Numatytina
        tokia sąlyga: pvz.: viena šalis perdavė kitai šaliai faktiškai naudotis
        pirkimo-pardavimo objektą, o antroji šalis sumokėjo pirmajai sutartą
        kainą, ir nors dėl kokių nors kliūčių oficialiai negalėjo tuo pat metu
        įforminti sandorį iki galo, tai, žinodami LR CK normą,
        kad&nbsp;įsipareigojimas parduoti daiktą, kartu perduodant jį
        būsimiesiems pirkėjams valdyti, yra to daikto pirkimas-pardavimas, ir
        kai įsipareigojęs pirkti ar parduoti daiktą asmuo atsisako įforminti
        sutartį nustatyta forma, kita šalis turi teisę per teismą reikalauti
        patvirtinti sutarties sudarymą (CK 6,317 str.).
      </p>
      <p>
        Sudarant preliminarią sutartį, verta numatyti, kad šalis, kalta dėl
        sutarties sąlygų sulaužymo, gali kreiptis į teismą dėl numatytų sankcijų
        taikymo, reikalauti abipusės restitucijos ir iš kaltosios šalies turėtų
        išlaidų, žalos bei kitų nuostolių atlyginimo, arba reikalauti pripažinti
        sandorį įvykusiu.
      </p>
      <p>
        <strong>Preliminarioji sutartis būtinai turi būti rašytinė</strong>.
        Žodinė – negalioja.
      </p>
      <p>
        <strong>Būtina nurodyti terminą pagrindinei sutarčiai sudaryti</strong>.
        Jo nenurodžius, pagrindinė sutartis turi būti sudaryta per vienerius
        metus nuo preliminariosios sutarties sudarymo. Visi įduodami pinigai
        vadinami ne rankpinigiais, bet <strong>avansine įmoka</strong>. Sutartį
        pravartu papildyti perleidžiamo turto nuosavybės dokumentų nuorašais
        arba bent jų kopijomis.
      </p>
      <p>
        Kaip betikėtum savo sandorio partneriu, vis vien pravartu preliminarią
        sutartį susirašyti ir joje nurodyti visas aptartas sąlygas ir
        aplinkybes. Praktika rodo, kad, bėdai prispaudus, „sušlubuoja“ žmonių
        atmintys, o radę geresnių ar pelningesnių būdų, partneriai atsisako savo
        žodžių, išsisukinėja… Be to, įvykus nelaimei (mirties arba veiksnumo
        netekimo atvejais), teisių perėmėjai ar globėjai perims vykdymui tik
        protingai ir teisiškai suformuluotas sąlygas. Kai būsimasis partneris
        miršta, įpėdiniai kartais linkę prisiimti tik naudą, ignoruodami
        pareigas ir prievoles. Preliminarioji sutartis tais atvejais tampa
        nenuginčijamu įrodymu. Kuo detaliau aprašytos visos sąlygos, tuo mažiau
        būna ginčų su įpėdiniais.
      </p>
      <p>
        Būna atvejų, kai faktiškai jau parduotas turtas areštuojamas arba į jį
        nukreipiamas išieškojimas. Nesant tokios sutarties, faktinis įgijėjas
        atsidurtų beviltiškoje situacijoje. Turint detalią preliminariąją
        sutartį, pagrįstą kitais dokumentais bei įrodymais, įgijėjas ir tokiu
        atveju dar turės vilčių savo interesą apginti teisme.
      </p>
    </div>
  </div>
</template>
